import { Link } from 'react-router-dom'
import { CautionIcon, openQueriesText, useOpenQueries } from '../lib/openQueries'
import styles from './QueriesAlert.module.css'

// The Dashboard's banner while pickers' queries are open (lib/openQueries.tsx): each one is someone waiting on
// the office about their pay, so it sits above the figures until the last is resolved.
export function QueriesAlert() {
  const open = useOpenQueries()
  if (!open) return null
  return (
    <div className={styles.alert} role="status" data-testid="queries-alert">
      <CautionIcon className={styles.icon} title="Needs attention" />
      <p className={styles.message}>
        {openQueriesText(open)}, waiting on an answer. {open === 1 ? 'They are' : 'Each picker is'} emailed when you resolve it.
      </p>
      <Link className={styles.link} to="/queries">
        Look into {open === 1 ? 'it' : 'them'}
      </Link>
    </div>
  )
}
